//# sourceMappingURL=maintenance_styles.mjs.map
/// <reference types="./maintenance_styles.d.mts" />
import * as $text from "../../../ds/ds/typography/text.mjs";
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { px } from "../../../sketch/sketch/css/length.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import { toList } from "../../gleam.mjs";

export function active_card(attrs, children) {
  let _pipe = $css.class$(toList([]));
  return $h.div(_pipe, attrs, children);
}

export function active_card_title(attrs, children) {
  let _pipe = $css.class$(toList([]));
  return $h.div(_pipe, attrs, children);
}

export function active_card_body(attrs, children) {
  let _pipe = $css.class$(toList([]));
  return $h.div(_pipe, attrs, children);
}

export function add_card(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.flex_direction("column"),
      $css.gap(px(12)),
      $css.min_width(px(350)),
    ]),
  );
  return $h.form(_pipe, attrs, children);
}

export function add_submit(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.justify_content("end"),
      $css.padding_top(px(12)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}

export function select_all(attrs, children) {
  let _pipe = $css.class$(
    toList([
      $css.display("flex"),
      $css.align_items("center"),
      $css.gap(px(8)),
      $css.compose($text.sm($text.regular)),
    ]),
  );
  return $h.div(_pipe, attrs, children);
}
